import {
  Alert,
  Heading,
  Paragraph,
  Skeleton,
} from "@digdir/designsystemet-react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { httpClient } from "@/api/client";
import { getAvtalePerioderOptions } from "@/api/generated/@tanstack/react-query.gen";
import { FormWrapper } from "@/components";
import { AvtalePeriodeForm } from "../forms/AvtalePeriodeForm";
import { FormPage } from "./FormPage";

export const AvtalePeriodePage = () => {
  const { t } = useTranslation();

  const {
    data: avtalePerioderResponse,
    isLoading,
    isError,
  } = useQuery({
    ...getAvtalePerioderOptions({
      client: httpClient,
    }),
  });

  return (
    <FormPage>
      <Heading data-size="lg">{t("pages.periode.tittel")}</Heading>
      <Paragraph
        data-size="lg"
        className="text-balder-text-subtle whitespace-pre-line"
      >
        {t("pages.periode.beskrivelse")}
      </Paragraph>
      {isLoading && (
        <FormWrapper>
          <Skeleton variant="text" width={40} className="w-50 h-7" />
          <Skeleton className="w-full h-12" />
          <Skeleton variant="circle" className="w-42 h-12" />
        </FormWrapper>
      )}
      {isError && (
        <Alert data-color="danger">
          <Heading data-size="xs">{t("skjema.feil-ved-henting")}</Heading>
          <Paragraph>{t("pages.periode.feil.hent")}</Paragraph>
        </Alert>
      )}
      {!isLoading &&
        !isError &&
        avtalePerioderResponse?.gyldigePerioder != null && (
          <AvtalePeriodeForm
            perioder={avtalePerioderResponse?.gyldigePerioder}
          />
        )}
    </FormPage>
  );
};
